import { ChangeDetectionStrategy, Component, Input, TemplateRef, inject } from '@angular/core';

import { HeaderUserService } from '@hdms/shared/page-frame/data-access';
import { UserAccountData } from '@hdms/shared/page-frame/types';
import {
  EnvironmentService,
  SlideInOutDimension,
  StorageService,
  StorageType,
  slideInOut
} from '@hdms/shared/util-core';

import { STORAGE_KEY_LOGIN_CLICKED } from '../../config/header.const';
import { HeaderConfigService } from '../../services';

@Component({
  selector: 'shrd-pf-ft-user-wrapper',
  templateUrl: './header-user-wrapper.component.html',
  styleUrls: ['./header-user-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInOut('labelSlide', SlideInOutDimension.WIDTH, 0.1)]
})
export class HeaderUserWrapperComponent {
  @Input() loggedUserTemplateRef: TemplateRef<Element>;
  @Input() showProfileIcon = true;
  @Input() userData: UserAccountData;

  readonly loginUrl$ = inject(HeaderConfigService).loginUrl$;
  readonly inHostContext = !!inject(EnvironmentService).hostContext;
  private readonly storageService = inject(StorageService);
  private readonly userService = inject(HeaderUserService);

  /**
   * Login click will redirect to other applications, set storage for login tracking after redirect back.
   */
  loggedInButtonClicked(): void {
    this.userService.setLoadingState();
    this.storageService.setItem(STORAGE_KEY_LOGIN_CLICKED, true, StorageType.SESSION, true);
  }
}
